export interface LoyaltyBalance {
  balanceTypeCode: string;
  balanceTypeDesc: string;
  balanceAmt: number;
}

export interface LoyaltyMemberAnnualBalance {
  balanceStartLocalDate: string;
  loyaltyBalances: LoyaltyBalance[];
}

export interface PersonName {
  namePrefixCode?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  nameSuffixCode?: string;
}

export interface Threshold {
  thresholdTypeCode: string;
  thresholdTypeDesc: string;
  thresholdAmt: number;
  spendPartnerCode?: string;
  spendThruDate?: string;
  balanceAmt: number;
  remainderAmt: number;
  percentCompleteNum: string;
  percentRemainderNum: string;
  thresholdMet: boolean;
}

export interface MedallionThresholdCombination {
  thresholdCombinationDesc: string;
}

export interface LoyaltyMemberProgramBalance {
  balanceStartLocalDate: string;
  loyaltyBalances: LoyaltyBalance[];
}

export interface LoyaltyMemberTierLevel {
  tierStatusDesc: string;
  tierLevelClassificatinCode: string;
  tierLevelCode: string;
  tierLevelCodeDesc: string;
  tierLevelStartLocalDate: string;
  tierLevelEndLocalDate: string;
  tierComp: boolean;
  tierMethodOfAttainmentCode?: string;
  tierValidThruEndLocalDate?: string;
  tierNextPeriodDowngrade?: boolean;
  tierNextPeriodDowngradedTierLevelCode?: string;
  tierNextPeriodDowngradedTierLevelDesc?: string;
}

export interface MedallionStatus {
  programYearNum?: string;
  programYearDesc?: string;
  programYearStartLocalDate?: string;
  programYearEndLocalDate?: string;
  earnYearStartLocalDate?: string;
  earnYearEndLocalDate?: string;
  regionCode?: string;
  eligibleMQDWaiver?: boolean;
  trackingToTierLevelCode?: string;
  trackingToTierLevelDesc?: string;
  medallionThresholdLevels?: LoyaltyBalance[];
  medallionThresholdCombinations?: MedallionThresholdCombination[];
  loyaltyMemberThresholds?: Threshold[];
}

export interface DSCSpend {
  statusDesc: string;
  spendThruDate: string;
  medallionYear: string;
  thresholdAmt: number;
  spentAmt: number;
  remainderAmt: number;
  percentCompleteNum: string;
  percentRemainderNum: string;
  thresholdMet: boolean;
}

export interface DscSpendTracker {
  affiliationTypeCode: string;
  affiliationTypeDesc: string;
  affiliationId: string;
  unlimitedDSCDiscontinueDate?: string;
  DSCSpend: DSCSpend[];
}
